import { render } from "./Edit.vue?vue&type=template&id=5a79582e"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrisu/Documents/CHRISUmedia/repos/Laravel/pingcrm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__